export default function StudentBenefits() {
  const benefits = [
    {
      icon: 'ri-graduation-cap-line',
      title: '学生・若年層限定の特典',
      description: '在学中や29歳以下の方は年会費優遇、ポイント還元率アップなど、若い世代だけの特別な優待が受けられます。'
    },
    {
      icon: 'ri-shield-check-line',
      title: '審査が通りやすい',
      description: '学生・若年層向けカードは収入が少なくても審査に通りやすく設計されています。アルバイト収入でもOK。'
    },
    {
      icon: 'ri-book-open-line',
      title: '金融リテラシーが身につく',
      description: '若いうちからクレジットカードを使うことで、お金の管理能力や信用情報の重要性を学べます。'
    },
    {
      icon: 'ri-gift-line',
      title: '将来も継続利用可能',
      description: '卒業後や30歳以降も一般カードに自動切替。若い時代に築いた信用履歴がそのまま引き継がれます。'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h3 className="text-3xl font-bold text-center mb-4 text-[#003366]">
          学生・29歳以下がクレジットカードを持つメリット
        </h3>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          学生や29歳以下の若い世代のうちからクレジットカードを持つことには、多くのメリットがあります。将来のために今から始めましょう。
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-[#14B8A6] to-[#0F9B8E] rounded-full flex items-center justify-center mb-4">
                <i className={`${benefit.icon} text-white text-2xl w-8 h-8 flex items-center justify-center`}></i>
              </div>
              <h4 className="text-xl font-bold mb-3 text-[#003366]">{benefit.title}</h4>
              <p className="text-gray-700 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        {/* FAQ */}
        <div className="mt-16">
          <h4 className="text-2xl font-bold text-center mb-8 text-[#003366]">
            学生・29歳以下のよくある質問
          </h4>
          <div className="space-y-4 max-w-3xl mx-auto">
            <div className="bg-white rounded-lg p-6 shadow-md">
              <h5 className="font-bold text-lg mb-2 text-[#003366]">Q. アルバイトをしていなくても作れますか？</h5>
              <p className="text-gray-700">A. はい、多くの学生・若年層向けカードはアルバイト収入がなくても申し込み可能です。学生の場合は親権者の同意があれば審査に通る可能性が高いです。</p>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-md">
              <h5 className="font-bold text-lg mb-2 text-[#003366]">Q. 利用限度額はいくらですか？</h5>
              <p className="text-gray-700">A. 学生の場合、通常10万円〜30万円程度に設定されます。社会人の29歳以下の方は収入に応じて30万円〜50万円程度になることもあります。</p>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-md">
              <h5 className="font-bold text-lg mb-2 text-[#003366]">Q. 卒業後や30歳以降はどうなりますか？</h5>
              <p className="text-gray-700">A. 卒業後や30歳以降は自動的に一般カードに切り替わります。若い時代の利用実績が信用情報として残るため、将来のローン審査などで有利になります。</p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <a
            href="#ranking"
            className="inline-block bg-[#14B8A6] text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-[#0F9B8E] transition-all cursor-pointer whitespace-nowrap shadow-lg"
          >
            学生・29歳以下向けカードを今すぐチェック
          </a>
        </div>
      </div>
    </section>
  );
}